import React from 'react'
import { hideSplashscreen } from 'src/services'
import { loadLocaleData } from 'labguard-cdk'
import { AccountContext } from 'src/contexts'
import I18n from '../I18n'

/**
 * Wrapper around the I18n component that uses lang and locale of the current user
 */
export default function AccountI18n(props) {
  const {
    account: { lang = {}, locale = {} },
  } = AccountContext.use()

  return <I18n {...props} langId={lang.id} localeId={locale.id} onLocaleLoad={onLocaleLoad} />
}

const onLocaleLoad = locale => {
  loadLocaleData(locale).then(hideSplashscreen)
}
